import { PotentialThemeColorType } from '~/theme';
import { useRawHtml } from './hooks';
import { TextBlock } from '~/shared/components/TextBlock';
import { StrokeTextMode } from '../StrokeText';

export type RawHtmlProps = {
    html?: string;
    backgroundColor?: PotentialThemeColorType;
    linkStrokeMode?: StrokeTextMode;
    interpolation?: Record<string, string | number>;
    className?: string;
};

export const RawHtml = ({
    html,
    backgroundColor,
    linkStrokeMode,
    interpolation,
    className,
    ...rest
}: RawHtmlProps) => {
    const markup = useRawHtml({ html, backgroundColor, linkStrokeMode, interpolation });
    return <TextBlock className={className} children={markup} {...rest} />;
};
